// Retorna o path da primeira rota do painel que o usuário tem permissão de acessar.
// Espelha a filtragem da BarraLateral (nível + módulo + permissão) para evitar que
// o usuário caia numa página cujo endpoint dispara 401 e derruba a sessão — caso do
// subadmin sem "Listar cambista" que caía na rota "/" e voltava para o login.
export default function primeiraRotaPermitida(usuario, rotas) {
  const permissoes = usuario?.permissoes ?? [];
  const modulos = usuario?.modulosAtivos ?? usuario?.modulos ?? [];
  const nivel = usuario?.nivel;

  const rota = (rotas ?? [])
    .filter((r) => r.showBar)
    .find((r) => {
      if (r.module && r.module.length > 0 && !r.module.some((m) => modulos.includes(m))) {
        return false;
      }

      if (r.nivel) {
        return r.nivel.includes(nivel);
      }

      return (r.permissions ?? []).some((p) => permissoes.includes(p));
    });

  // Fallback: troca de senha costuma estar disponível para qualquer perfil do painel.
  return rota?.path ?? '/senha';
}
